import WebsocketHeartbeatJs from 'websocket-heartbeat-js';
import { BASE_URL_WEBSOCKET } from '@/globalConfig';
import EventBus from '@/eventBus.ts';

let Socket = '';
// let wsUrl = window.location.origin.replace('http', 'ws').replace('https', 'ws');

// if (process.env.NODE_ENV === 'development') {
// let wsUrl = 'ws://192.168.0.155:8080';
let wsUrl = BASE_URL_WEBSOCKET;
// }

/**
 * 发送数据但连接未建立时进行处理等待重发
 * @param {any} message 需要发送的数据
 */
const connecting = (message) => {
  setTimeout(() => {
    if (Socket.ws.readyState === 0) {
      connecting(message);
    } else {
      //   Socket.send(JSON.stringify(message));
      Socket.send(message);
    }
  }, 1000);
};

/**WS 数据接收统一处理 */
const onmessageWS = (e) => {
  const data = JSON.parse(e.data);
  console.log('------data :>> ', data);
  const { topic, content } = data;
  if (topic == 'i3d') {
    const modelCode = JSON.parse(content)['command'][0].id;
    // 如果topic是i3d则表示是双击了摄像头，需要弹框
    EventBus.$emit('showVideoModal', true);
    EventBus.$emit('curVideoModalCode', modelCode);
  }
  switch (data.success_name) {
    case '登陆成功！':
      console.log(data.success_name);
      break;
  }
  window.dispatchEvent(
    new CustomEvent('onmessageWS', {
      detail: { data },
    })
  );
};

/**
 * 发送数据
 * @param {any} message 需要发送的数据
 */
export const sendWSPush = (message) => {
  Socket.send(JSON.stringify(message));
  //   if (Socket !== null && Socket.ws.readyState === 3) {
  //     Socket.close();
  //     createSocket();
  //   } else if (Socket.ws.readyState === 1) {
  //     Socket.send(JSON.stringify(message));
  //   } else if (Socket.ws.readyState === 0) {
  //     connecting(message);
  //   }
};

// 登录
const login = () => {
  const data = {
    cus_id: 'i3yoo',
    userid: '584f',
    timestamp: '1580978250',
    loginkey: 'e03a8b44387832679594de2ddb7f88b712a4255d',
  };
  sendWSPush({
    type: 'login',
    data_type: 'json',
    data: data,
  });
};

const onopenWS = () => {
  console.log('### websocket 连接成功！');
  // 连上之后登录
  //   login();
};

/**
 * 建立 websocket 连接
 * https://github.com/zimv/websocket-heartbeat-js 心跳检测的 websocket 库
 */
export const createSocket = () => {
  //   const url = `${wsUrl}?rnd=${Math.ceil(Math.random() * 1000)}`;
  const url = `${wsUrl}`;
  const options = {
    url,
    pingTimeout: 120000, // 未收到消息多少秒之后发送 ping 请求，默认 15000 毫秒
    pongTimeout: 5000, // 发送 ping 之后，未收到消息超时时间，默认 10000 毫秒
    reconnectTimeout: 2000, // 重连的间隔时间
    pingMsg: JSON.stringify({
      topic: 'front',
      content: {
        command: [{ viewpoint_code: `JK001` }],
      },
    }),
  };
  if (!Socket) {
    console.log('开始建立 websocket 连接');
    Socket = new WebsocketHeartbeatJs(options);
    Socket.onopen = onopenWS;
    Socket.onmessage = onmessageWS;
  } else {
    console.log('websocket 已连接');
  }
};
